import { Box, Button, Icon, ModuleHeaderSlot, SearchField, Tooltip } from "@tm/components"
import { useState } from "react"
import { useLocalization } from "@tm/localization"
import { useParams } from "react-router"
import { getBundleParams } from "@bundles/compilations/utils"
import { AddNewListButton } from "./AddNewListButton"
import { useFavoriteArticlesStore } from "../store"

type OptionsProps = {
    loadingCompilationPdf?: boolean
    onPrintButtonClick(): void
}

export function Options(props: OptionsProps) {
    const { loadingCompilationPdf, onPrintButtonClick } = props
    const { selectedCompilation, query, setQuery } = useFavoriteArticlesStore()

    const { translateText } = useLocalization()
    const { showPrintButton } = getBundleParams()
    const { listId } = useParams<{ listId?: string }>()

    const [searchText, setSearchText] = useState(query ?? "")

    function handleStartSearch() {
        setQuery(searchText)
    }

    function handleClearSearch() {
        setQuery("")
    }

    return (
        <>
            <ModuleHeaderSlot title={translateText(135)}>
                <SearchField
                    id="compilationsSearch"
                    onStartSearch={handleStartSearch}
                    value={searchText}
                    onChange={setSearchText}
                    onClear={handleClearSearch}
                    placeholder={translateText(1770)}
                    inputProps={{ maxLength: 100 }}
                    size="small"
                />
            </ModuleHeaderSlot>
            {(!selectedCompilation || showPrintButton) && (
                <ModuleHeaderSlot title={translateText(177)}>
                    {!selectedCompilation && <AddNewListButton />}
                    {showPrintButton && (
                        <Tooltip title={translateText(49)}>
                            <Box>
                                <Button
                                    disabled={!listId || loadingCompilationPdf}
                                    onClick={onPrintButtonClick}
                                    startIcon={<Icon name="print" />}
                                    variant="outlined"
                                />
                            </Box>
                        </Tooltip>
                    )}
                </ModuleHeaderSlot>
            )}
        </>
    )
}
